'use client';

import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

// `env` arrives as a prop rather than from process.env: the deployable
// environment is resolved when the server starts, so inlining it into the
// client bundle at build time would tie the build to one environment.
const DatadogLogs: React.FC<{ env: string }> = ({ env }) => {
  useEffect(() => {
    if (process.env.DATADOG_CLIENT_TOKEN) {
      datadogLogs.init({
        clientToken: process.env.DATADOG_CLIENT_TOKEN,
        version: process.env.NEXT_PUBLIC_APP_VERSION,
        site: 'datadoghq.com',
        service: 'interstitial-client-next',
        forwardErrorsToLogs: false,
        // console.logs will not be automatically forwarded to Datadog Logs
        // instead, we will use datadogLogs.logger to explicitly log messages
        // to Datadog
        forwardConsoleLogs: [],
        sessionSampleRate: env === 'prod' ? 0 : 100,
        env,
      });
    }
  }, [env]);

  return null;
};

export { datadogLogs };

export default DatadogLogs;
